import { ReactComponent as InfoIcon } from 'assets/icons/Layer_2.svg';
import { useAuth0 } from "@auth0/auth0-react";
import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import NewDialog from "components/NewDialog/Dialog";
import Button from "components/button/Button";
import { useFormik } from "formik";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { toastr } from "react-redux-toastr";
import thousands from "thousands";
import ReportService from "../../../Lib/API/Report";
import Loader from "../../../assets/gif/Loader.gif";
import Report1 from "../docs/report1";
import { Filter } from "./filter.jsx";
import "./index.scss";
import { fontConfig } from "theme/fontConfig";

const Report = ({ setOpenReport,closeModal, type, reportIndex,reportName }) => {
  const initialFilters = {
    reportId: type,
  };
  const { getAccessTokenSilently } = useAuth0();
  const [filters, setFilters] = useState(initialFilters);
  const [reportsData, setReportsData] = useState([]);
  const [successfully, setSuccessfully] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openReport1, setOpenReport1] = useState(false);
  const [downloadFile, setDownloadFile] = useState(false);
  const inputRef = useRef(null);
  const [docData, setDocData] = useState("");
  const [logoImage, setLogoImage] = useState(null);
  const [bol, setBol] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [reportsFiltersPayload,setReportsFiltersPayload]=useState({})
  const [totals,setTotals]=useState({})
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: { all_ledger_sub_data: [], ledger: [], subLedger: [],account:{detailedByFamily:false, detailedByPaymentMethod: false,} },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });
  const filterData = reportName === "Credit on Account" ? {
    filter: {
      ...(formik.values.account?.accounts?.length && {
        accountIds: formik.values.account?.accounts?.map(item => item._id),
      }),
    },
    reportId: filters?.reportId,
  } : {
    filter:{
    ...filters?.filter,
    account_type: formik.values.account?.account_type?.[0] === '-1' ? ['-1'] : formik.values.account?.account_type?.map(item => item.value),
    billing_type: formik.values.account?.billing_type?.[0] === '-1' ? ['-1'] : formik.values.account?.billing_type?.map(item => item.title),
    accounts: formik.values.account?.accounts?.[0] === '-1' ? ['-1'] : formik.values.account?.accounts?.map(item => item._id),
    category: formik.values.account?.category?.[0] === '-1' ? ['-1'] : formik.values.account?.category?.map(item => item.title),
    ...(reportName === "Payment by payment method type" ? {
      detailedByPaymentMethod: formik.values.account?.detailedByPaymentMethod,
      paymentMethod:formik.values.account?.paymentMethod?.[0] === '-1' ? ['-1'] : formik.values.account?.paymentMethod?.map(item => item.title)
    } : {detailedByFamily:formik.values.account?.detailedByFamily}),
    includeAccountInformation: formik.values.account?.includeAccountInformation,

    },
    reportId:filters?.reportId
  }

  useEffect(() => {
    setLogoImage(localStorage?.getItem("Base64"));
  }, []);
  const isDisabledFilter = ()=>{
    if(reportName === "Ledger account summary") {
      if(filters?.filter?.dateRange && filters?.filter?.date){
        return false
      }else{
        return true
      }
    }
    else if(reportName === "Credit on Account"){
      return false
    }
    else if(reportName === "Aged account receivable summarized by Ledger"
    || reportName === "Aged account receivable summarized by Family"
    ){
      if(filters?.filter?.date){
        return false
      }else{
        return true
      }
    }else{
      if(filters?.filter?.dateRange){
        return false
      }else{
        return true
      }
    }
  }
  const styles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "20px",
    },
    printedOn: {
      // marginTop: '1rem',
      fontSize: "12px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "150px",
    },
    ChargeDetailCol: {
      width: "180px",
    },
    AmountCol: {
      width: "150px",
    },
    AmountPaidCol: {
      width: "150px",
    },
    AmountDueCol: {
      width: "150px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "5pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "10px",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
  });

  useEffect(() => {
    if (downloadFile) {
      html2canvas(inputRef.current)
        .then((canvas) => {
          const pdf = new jsPDF();
          pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, 211, 298);
          pdf.save("table.pdf");
        })
        .then((canvas) => {
          const pdf = new jsPDF();
          let width = 200;
          let height = 0;
          const imgData = canvas.toDataURL("image/png");
          pdf.addImage(imgData, "PNG", 5, 5, width, height);
          pdf.save("Statement.pdf");
          setDownloadFile(false);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
  }, [downloadFile]);

  const onSearchChange = (e) => {
    const name = e.target.value;
    setFilters((prev) => ({
      ...prev,
      search: name ? name : undefined,
    }));
  };

  const handelDelete = () => {
    setDownloadFile(true);
  };

  const handelView = () => {
    setOpenReport1(true);
  };


  const calculatingReportTotal = (reports) => {
    switch(reportName) {
      case "Aged account receivable summarized by Ledger":
        const totalsCalc = reports?.map((item) => item?.total).reduce((a, b) => a + b, 0);
        const totalPrepaysCalc = reports?.map((item) => item?.totalPrepays).reduce((a, b) => a + b, 0);
        const transactionTotals = reports?.reduce((acc, item) => {
          const { transactions } = item || {};
          
          if (transactions) {
            transactions.forEach((transaction) => {
              const date = transaction?.date;
              const totalAmount = transaction?.totalAmount || 0;
        
              if (date === "0-30") {
                acc.totalOf30Days += totalAmount;
              } else if (date === "30-60") {
                acc.totalOf60Days += totalAmount;
              } else if (date === "60-90") {
                acc.totalOf90Days += totalAmount;
              } else if (date === "90+") {
                acc.totalOfOver90Days += totalAmount;
              }
            });
          }
        
          return acc;
        }, { totalOf30Days: 0, totalOf60Days: 0, totalOf90Days: 0, totalOfOver90Days: 0 });
        setTotals({totalsCalc,totalPrepaysCalc,...transactionTotals})
        break;
      case "Billing Summarized by Ledger": 
        const totalsOfFamilies = reports?.map((item) => item?.families).reduce((a, b) => a + b, 0);
        const totalsOfBilled = reports?.map((item) => item?.billed).reduce((a, b) => a + b, 0);
        const totalsOfPaid = reports?.map((item) => item?.paid).reduce((a, b) => a + b, 0);
        const totalsOfAdjusted = reports?.map((item) => item?.adjusted).reduce((a, b) => a + b, 0);
        const totalsOfBalance = reports?.map((item) => item?.balance).reduce((a, b) => a + b, 0);
        setTotals({totalsOfFamilies,totalsOfBilled,totalsOfPaid,totalsOfAdjusted,totalsOfBalance})
      break;
      case "Ledger account summary":
        const ledgerTotalsCalc = reports?.map((item) => item?.total).reduce((a, b) => a + b, 0);
        const ledgerTotalPrepaysCalc = reports?.map((item) => item?.totalPrepays).reduce((a, b) => a + b, 0);
        const ledgerTransactionTotals = reports?.reduce((acc, item) => {
          const { transactions } = item || {};
          if (transactions) {
            transactions.forEach((transaction) => {
              const date = transaction?.date;
              const totalAmount = transaction?.totalAmount || 0;
        
              if (date === "0-30") {
                acc.totalOf30Days += totalAmount;
              } else if (date === "30-60") {
                acc.totalOf60Days += totalAmount;
              } else if (date === "60-90") {
                acc.totalOf90Days += totalAmount;
              } else if (date === "90+") {
                acc.totalOfOver90Days += totalAmount;
              }
            });
          }
          return acc;
        }, { totalOf30Days: 0, totalOf60Days: 0, totalOf90Days: 0, totalOfOver90Days: 0 });
        setTotals({ledgerTotalsCalc,ledgerTotalPrepaysCalc,...ledgerTransactionTotals})
        default:
        break;
    }
  }

  const handleFilterReports = async () => {  
    setLoading(true);
    const token = await getAccessTokenSilently();
    await ReportService.getReportByFilter(token, filterData)
      .then((res) => {
        const result = res.result;
        calculatingReportTotal(result)
        setReportsData(result);
        setReportsFiltersPayload(res?.payload);
        setDocData(result);
        setSuccessfully(true);
        setLoading(false);
        setBol(true);
        setTimeout(() => {
          setBol(false);
        }, 3000);
        handelView()
        
      })
      .catch((err) => {
        if (err?.data?.message?.includes("batchId")) {
          toastr.error("Wrong Batch ID");
        } else if (err?.data?.message?.includes("must be a valid date")) {
          toastr.error("must be a valid date");
        }
        setLoading(false);
        setFilters(initialFilters);
      });
  };

  const getTransactionAmountAndFormatted = (records, date) => {
    const totalAmount =
      records
        ?.flatMap((hh) => hh?.transactions || [])
        ?.filter((o) => o.date === date)
        ?.reduce((partialSum, o) => partialSum + (+o.totalAmount || 0), 0) || 0;

    const formattedAmount = totalAmount
      ? thousands(Number(totalAmount).toFixed(2))
      : "0.00";

    return { totalAmount, formattedAmount };
  };

  const getTransAmountAndFormatted = (records, date) => {
    const transaction = records?.find((o) => o.date === date);
    const totalAmount = transaction?.totalAmount ?? 0;

    const formattedAmount = totalAmount
      ? thousands(Number(totalAmount).toFixed(2))
      : "0.00";

    return { totalAmount, formattedAmount };
  };

  // PDF document component
  const TaxStatementPdf = () => (
    <Document>
      {reportsData &&
        reportsData?.map((item, index) => {
          const { formattedAmount: ResultformattedAmount } =
            getTransactionAmountAndFormatted(item?.records, "0-30");
          const { formattedAmount: ResultformattedAmount30_60 } =
            getTransactionAmountAndFormatted(item?.records, "30-60");
          const { formattedAmount: ResultformattedAmount60_90 } =
            getTransactionAmountAndFormatted(item?.records, "60-90");
          const { formattedAmount: ResultformattedAmount90 } =
            getTransactionAmountAndFormatted(item?.records, "90+");
          const { formattedAmount: ResultformattedAmountPrepays } =
            getTransactionAmountAndFormatted(item?.records, "Prepays");

          return (
            <Page key={index}>
              <View>
                {/* Render account details */}
                <View>
                  <Text style={styles.docOrgDetailsAddress}>
                    {item?.account?.family_name}
                  </Text>
                </View>
                <View>
                  <Text style={styles.docOrgDetailsAddress}>
                    {item?.account?.addresses?.map((add) => {
                      return (
                        <p className="m-0">{`${add?.city ?? ""} ${
                          add?.country ?? ""
                        }`}</p>
                      );
                    })}
                  </Text>
                </View>
                <View>
                  <Text style={styles.docOrgDetailsAddress}>
                    {item?.account?.main_contact?.email_address ??
                      item?.account?.primary_email_address}
                  </Text>
                </View>
                <View>
                  <Text style={styles.docOrgDetailsAddress}>
                    {item?.account?.main_contact?.mobile_number ??
                      item?.account?.primary_phone_number}{" "}
                  </Text>
                </View>

                {/* Render transaction details */}
                <View style={styles.BodyRow}>
                  <Text style={styles.DateCol}>{""}</Text>
                  <Text style={styles.DateCol}>{""}</Text>
                  <Text style={styles.DateCol}>{"Total"}</Text>
                  <Text style={styles.DateCol}>{" 0-30 Days"}</Text>
                  <Text style={styles.DateCol}>{"30-60 Days"}</Text>
                  <Text style={styles.DateCol}>{"60-90 Days"}</Text>
                  <Text style={styles.DateCol}>{"over 90 Days"}</Text>
                  <Text style={styles.DateCol}>{"Prepays"}</Text>
                </View>
                {item?.records?.map((tran, i) => {
                  const { totalAmount: formattedAmount0_30 } =
                    getTransAmountAndFormatted(tran?.transactions, "0-30");
                  const { totalAmount: formattedAmount30_60 } =
                    getTransAmountAndFormatted(tran?.transactions, "30-60");
                  const { totalAmount: formattedAmount60_90 } =
                    getTransAmountAndFormatted(tran?.transactions, "60-90");
                  const { totalAmount: formattedAmount90 } =
                    getTransAmountAndFormatted(tran?.transactions, "90+");
                  const { totalAmount: formattedAmountprepays } =
                    getTransAmountAndFormatted(tran?.transactions, "Prepays");

                  return (
                    <View>
                      {/* Render transaction details */}
                      <View style={styles.BodyRow}>
                        <Text style={styles.DateCol}>
                          {tran?.Ledger} /{tran?.SubLedger}
                        </Text>
                        <Text style={styles.DateCol}>{""}</Text>
                        <Text style={styles.DateCol}>{""}</Text>

                        <Text style={styles.ChargeDetailCol}>
                          ${formattedAmount0_30}
                        </Text>
                        <Text style={styles.AmountCol}>
                          ${formattedAmount30_60}
                        </Text>
                        <Text style={styles.AmountPaidCol}>
                          $ {formattedAmount60_90}
                        </Text>
                        <Text style={styles.AmountDueCol}>
                          ${formattedAmount90}
                        </Text>
                        <Text style={styles.AmountDueCol}>
                          ${formattedAmountprepays}
                        </Text>
                      </View>
                    </View>
                  );
                })}
                <View style={styles.totalRow}>
                  <Text style={styles.DateCol}>{""}</Text>
                  <Text style={styles.ChargeDetailCol}>{""}</Text>
                  <Text style={styles.AmountCol}>
                    {item?.total
                      ? thousands((+item?.total).toFixed(2))
                      : "0.00" ?? 0}
                  </Text>
                  <Text style={styles.AmountCol}>
                    $ {ResultformattedAmount}
                  </Text>
                  <Text style={styles.AmountCol}>
                    $ {ResultformattedAmount30_60}
                  </Text>

                  <Text style={styles.AmountCol}>
                    ${ResultformattedAmount60_90}
                  </Text>

                  <Text style={styles.AmountCol}>
                    ${ResultformattedAmount90}
                  </Text>

                  <Text style={styles.AmountCol}>
                    ${ResultformattedAmountPrepays}
                  </Text>
                </View>
              </View>
            </Page>
          );
        })}
    </Document>
  );
 
  return (
    <div className="reportModal">
      {loading == true ? (
        <>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <img src={Loader} width="200px" height="200px" />
          </div>
        </>
      ) : successfully == false ? (
        <>
          <div>
            {reportName === "Credit on Account" && (
              <div
                style={{
                  padding: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '20px',
                  marginLeft: '16px',
                  marginRight: '16px',
                  background: '#d3ddfc',
                  borderRadius: '4px',
                  fontFamily: fontConfig.ReportsReportTextFont.family,
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#2555ef',
                }}
              >
                <InfoIcon style={{ marginRight: '12px', minWidth: '18px' }} />
                All accounts with a Credit on Account balance will be included in this report. Accounts without a Credit on Account balance will not appear in the results.
              </div>
            )}
            <Filter
              onSearchChange={onSearchChange}
              setFilters={setFilters}
              filters={filters}
              reportIndex={reportIndex}
              type={type}
              reportName={reportName}
              formik={formik}
            />
          </div>
          <div>
            <div className="buttons">
            <Button 
              variant='primary-outline'
              size="md"
              style={{minWidth: 100}}
              onClick={closeModal}
             >
              Close
            </Button>
            <Button 
             variant='primary'
             size="md"
             style={{minWidth: 100}}
              disabled={isDisabledFilter()}
              onClick={() => {
                if(isDisabledFilter()) return;
                handleFilterReports();
              }}
             >
              {reportName === "Credit on Account" ? "Run" : "Save"}
            </Button>
              </div>
          </div>
        </>
      ) : (
        <>
        </>
      )}
        <>
        <NewDialog isOpen={openReport1}  
        handleClose={() => {
          setOpenReport(false);
          setOpenReport1(!openReport1);
          setFilters(initialFilters);
        }}
        sx={{ '& .MuiDialog-paperWidthSm': { minWidth: "68%", height: "95%" } }}
        content={
      <>
      <Report1
              type={type}
              data={reportsData}
              reportIndex={reportIndex}
              reportName={reportName}
              filterData={filterData}
              setIsExportLoading={setIsExportLoading}
              isExportLoading={isExportLoading}
              reportsFiltersPayload={reportsFiltersPayload}
              totals={totals}
              formik={formik}
            />
      </>
       }
        contentStyle={{ display: 'flex', justifyContent: 'center', height: '100%' }}
        buttonStyle={{ justifyContent: 'right' }}
      >
      </NewDialog>
      </>
    </div>
  );
};
export default Report;
